/* eslint-disable react/jsx-props-no-spreading */
import React, { FC, ReactElement } from 'react';
import { LinkProps } from 'react-router-dom';

import HybridLink from 'AppShell/components/Links/HybridLink';
import useRouter from 'AppShell/hooks/useRouter';
import { useIsBellaPageType, useIsClubMFUrl } from 'Client/hooks/UrlManager/pageTypeHooks';

export interface Props extends LinkProps {
    to: string;
    className?: string;
    isCurrentPage?: boolean;
    target?: string;
    isNavLink?: boolean;
    activeClassName?: string;
    testId?: string;
    'data-testid'?: string;
    [key: `data-${string}`]: string | undefined;
}

const ClubHybridLink: FC<Props> = ({ to: propsTo, children, ...rest }): ReactElement => {
    const { disableClientsideNavigation } = useRouter();
    const isBellaPageType = useIsBellaPageType();
    const { isBellaPage, relativeUrl } = isBellaPageType(propsTo);
    const isTargetAClubPage = useIsClubMFUrl(propsTo);

    const isExternalLink = isBellaPage || !isTargetAClubPage;

    const forceReload = isExternalLink || !!disableClientsideNavigation;

    const to = !forceReload && relativeUrl ? relativeUrl : propsTo;

    return (
        <HybridLink isExternalLink={forceReload} to={to} {...rest}>
            {children}
        </HybridLink>
    );
};

export default ClubHybridLink;
